import { i18n as headerBar } from "../components/HeaderBar";
import { i18n as qrExcursion } from "../components/QRExcursion";

export default {
  en: { ...headerBar.en, ...qrExcursion.en },
  es: { ...headerBar.es, ...qrExcursion.es },
};
